const ActionNames = require('../VerifoneActionNames');

/**
 * See "Ocius Payment Application Solution Integration Specification v2.5 - 11th September 2019.pdf" page 52.
 *
 * @type {{string: {id: number, message: string, customerFacingMessage?:string, icon?:string, actions?:string[]}}}}
 */
const Statuses = {
    WAITING_FOR_GRATUITY: {
        id: 1,
        message: 'Waiting For Gratuity',
        customerFacingMessage: 'Enter Gratuity',
        icon: 'pause',
    },
    GRATUITY_BEING_ENTERED: {
        id: 2,
        message: 'Gratuity Being Entered',
        icon: 'pause',
    },
    AWAITING_CARD: {
        id: 3,
        message: 'Awaiting Card',
        customerFacingMessage: 'Insert / Present Card',
        icon: 'pause',
        actions: [
            ActionNames.CANCEL_TRANSACTION,
        ],
    },
    SWIPE_CARD: {
        id: 4,
        message: 'Swipe Card',
        customerFacingMessage: 'Swipe Card',
        icon: 'pause',
    },
    CARD_INSERTED: {
        id: 5,
        message: 'Card Inserted',
        customerFacingMessage: 'Please Wait',
    },
    CARD_REMOVED: {
        id: 6,
        message: 'Card Removed',
        customerFacingMessage: 'Please Wait',
    },
    CARD_PROCESSING: {
        id: 7,
        message: 'Card Processing',
        customerFacingMessage: 'Do Not Remove Card',
    },
    CHANGE_CARD: {
        id: 8,
        message: 'Change Card',
        customerFacingMessage: 'Use Alternative Payment Method',
        icon: 'pause',
    },
    KEY_IN_CARD_DETAILS: {
        id: 10,
        message: 'Key In Card Details',
        customerFacingMessage: 'Key Card Number',
        icon: 'hand-up',
    },
    WAITING_FOR_CASHBACK: {
        id: 11,
        message: 'Waiting For Cashback',
        customerFacingMessage: 'Enter Cashback',
        icon: 'question-sign',
        actions: [
            ActionNames.CASHBACK_REQUIRED,
            ActionNames.CASHBACK_NOT_REQUIRED,
        ],
    },
    PIN_ENTRY: {
        id: 12,
        message: 'Pin Entry',
        customerFacingMessage: 'Enter PIN',
        icon: 'pause',
    },
    RISK_MANAGEMENT_COMPLETE: {
        id: 13,
        message: 'Risk Management Complete',
    },
    AUTHORISING_TRANSACTION: {
        id: 14,
        message: 'Authorising Transaction',
        customerFacingMessage: 'Please Wait',
    },
    WAITING_FOR_RESULT: {
        id: 15,
        message: 'Waiting For Result',
        customerFacingMessage: 'Please Wait',
    },
    AUTH_RESULT_RECEIVED: {
        id: 16,
        message: 'Auth Result Received',
        customerFacingMessage: 'Please Wait',
    },
    PRINTING_MERCHANT_RECEIPT: {
        id: 17,
        message: 'Printing Merchant Receipt',
        customerFacingMessage: 'Please Wait',
        icon: 'print',
    },
    SIGNATURE_CONFIRMATION_REQUIRED: {
        id: 18,
        message: 'Signature Confirmation Required',
        customerFacingMessage: 'Please Wait',
        icon: 'pencil',
        actions: [
            ActionNames.CONFIRM_SIGNATURE,
            ActionNames.REJECT_SIGNATURE,
        ],
    },
    CONTINUE_REQUIRED: {
        id: 19,
        message: 'Continue Required',
        icon: 'pause',
        actions: [
            ActionNames.CONTINUE_TRANSACTION,
        ],
    },
    CONFIRM_AUTH_CODE: {
        id: 20,
        message: 'Confirm Auth Code',
        icon: 'question-sign',
        actions: [
            ActionNames.CONFIRM_AUTH_CODE,
            ActionNames.REJECT_AUTH_CODE,
        ],
    },
    CONFIRMING_TRANSACTION: {
        id: 21,
        message: 'Confirming Transaction',
        customerFacingMessage: 'Please Wait',
    },
    REJECTING_TRANSACTION: {
        id: 22,
        message: 'Rejecting Transaction',
        customerFacingMessage: 'Declined',
    },
    FINAL_RESULT_RECEIVED: {
        id: 23,
        message: 'Final Result Received',
        customerFacingMessage: 'Please Wait',
    },
    VOICE_REFERRAL: {
        id: 24,
        message: 'Voice Referral',
        customerFacingMessage: 'Referral',
        actions: [
            ActionNames.VOICE_REFERRAL_AUTHORISED,
            ActionNames.VOICE_REFERRAL_REJECTED,
        ],
    },
    REMOVE_CARD: {
        id: 25,
        message: 'Remove Card',
        customerFacingMessage: 'Remove Card',
        icon: 'eject',
    },
    DOWNLOADING_FILE: {
        id: 28,
        message: 'Downloading File',
        customerFacingMessage: 'Loading',
    },
    UPDATING_PED: {
        id: 29,
        message: 'Updating PED',
        customerFacingMessage: 'Loading',
    },
    CARD_DATA_RETRIEVAL: {
        id: 31,
        message: 'Card Data Retrieval',
    },
    STARTING_TRANSACTION: {
        id: 32,
        message: 'Starting Transaction',
        customerFacingMessage: 'Please Wait',
    },
    PERFORMING_DOWNLOAD: {
        id: 33,
        message: 'Performing Download',
        customerFacingMessage: 'Loading',
    },
    REQUESTING_REPORT: {
        id: 34,
        message: 'Requesting Report',
        customerFacingMessage: 'Please Wait',
    },
    EXPIRY_DATE_REQUIRED: {
        id: 36,
        message: 'Expiry Date Required',
        customerFacingMessage: 'Expires MM/YY',
        icon: 'hand-up',
    },
    START_DATE_REQUIRED: {
        id: 37,
        message: 'Start Date Required',
        customerFacingMessage: 'Valid From MM/YY',
        icon: 'hand-up',
    },
    AVS_HOUSE_NUMBER_REQUIRED: {
        id: 39,
        message: 'AVS House Number Required',
        customerFacingMessage: 'Enter House Number',
        icon: 'hand-up',
    },
    AVS_POST_CODE_REQUIRED: {
        id: 40,
        message: 'AVS Post Code Required',
        customerFacingMessage: 'Enter Post Code',
        icon: 'hand-up',
    },
    CSC_REQUIRED: {
        id: 41,
        message: 'CSC Required',
        customerFacingMessage: 'Enter Card Security Code',
        icon: 'hand-up',
    },
    LOGIN_REQUIRED: {
        id: 45,
        message: 'Login Required',
        icon: 'warning-sign',
    },
    READY: {
        id: 46,
        message: 'Ready',
        customerFacingMessage: 'Ready',
        icon: 'ok-circle',
    },
    CARD_NOT_ACCEPTED: {
        id: 47,
        message: 'Card Not Accepted',
        customerFacingMessage: 'Not Accepted',
    },
    TRANSACTION_CANCELLED: {
        id: 49,
        message: 'Transaction Cancelled',
        customerFacingMessage: 'Transaction Void',
    },
    PRINTING_CUSTOMER_RECEIPT: {
        id: 53,
        message: 'Printing Customer Receipt',
        customerFacingMessage: 'Please Wait',
        icon: 'print',
    },
    INITIALISING_PED: {
        id: 54,
        message: 'Initialising PED',
        customerFacingMessage: 'Please Wait',
    },
    PED_UNAVAILABLE: {
        id: 55,
        message: 'PED Unavailable',
        icon: 'warning-sign',
        actions: [
            ActionNames.RETRY_DEVICE,
        ],
    },
    CARD_APPLICATION_SELECTION: {
        id: 56,
        message: 'Card Application Selection',
        customerFacingMessage: 'Select Payment Type',
    },
    RETRY_DOWNLOAD: {
        id: 57,
        message: 'Retry Download',
    },
    RESTART_AFTER_SOFTWARE_UPDATE: {
        id: 58,
        message: 'Restart After Software Update',
    },
    UNSAFE_DOWNLOAD: {
        id: 62,
        message: 'Unsafe Download',
    },
    UNEXPECTED_LOGIN: {
        id: 63,
        message: 'Unexpected Login',
        actions: [
            ActionNames.REPLACE_ACCOUNT,
            ActionNames.CANCEL_REPLACE_ACCOUNT,
        ],
    },
    REGISTER_FOR_ACCOUNT_ON_FILE_DECISION: {
        id: 68,
        message: 'Register For Account On File Decision',
        actions: [
            ActionNames.ACCOUNT_ON_FILE_REGISTRATION_REQUIRED,
            ActionNames.ACCOUNT_ON_FILE_REGISTRATION_NOT_REQUIRED,
        ],
    },
    AWAITING_TOKEN_ID: {
        id: 69,
        message: 'Awaiting Token ID',
    },
    DOWNLOAD_COMPLETE: {
        id: 74,
        message: 'Download Complete',
    },
    DOWNLOAD_STILL_BEING_PREPARED: {
        id: 75,
        message: 'Download Still Being Prepared',
    },
    SERVER_CONNECTION_FAILED: {
        id: 76,
        message: 'Server Connection Failed',
        actions: [
            ActionNames.ATTEMPT_TO_RECONNECT,
            ActionNames.GO_OFFLINE,
        ],
    },
    RESUME_DOWNLOAD: {
        id: 77,
        message: 'Resume Download',
    },
    CARD_ERROR: {
        id: 96,
        message: 'Card Error',
    },
    UPDATE_TRANSACTION_VALUE_DECISION: {
        id: 137,
        message: 'Update Transaction Value Decision',
    },
    INVALID_AMOUNT: {
        id: 145,
        message: 'Invalid Amount',
    },
    MERCHANT_REFERENCE_REQUIRED: {
        id: 146,
        message: 'Merchant Reference Required',
        actions: [
            ActionNames.MERCHANT_REFERENCE_ENTERED,
        ],
    },
    ENTER_AMOUNT: {
        id: 151,
        message: 'Enter Amount',
    },
    CONFIRM_AUTHORISATION: {
        id: 152,
        message: 'Confirm Authorisation',
    },
    CARD_EXPIRED: {
        id: 153,
        message: 'Card Expired',
    },
    INVALID_ACCOUNT: {
        id: 156,
        message: 'Invalid Account',
    },
    INVALID_CAPTURE_METHOD: {
        id: 157,
        message: 'Invalid Capture Method',
    },
    INVALID_CARD_NUMBER: {
        id: 158,
        message: 'Invalid Card Number',
    },
    INVALID_CONFIGURATION: {
        id: 159,
        message: 'Invalid Configuration',
    },
    INVALID_EXPIRY_DATE: {
        id: 160,
        message: 'Invalid Expiry Date',
    },
    INVALID_TRACK2_FORMAT: {
        id: 161,
        message: 'Invalid Track2 Format',
    },
    INVALID_TRANSACTION_TYPE: {
        id: 162,
        message: 'Invalid Transaction Type',
    },
    KEYED_ENTRY_NOT_ALLOWED: {
        id: 163,
        message: 'Keyed Entry Not Allowed',
    },
    CARD_SCHEME_NOT_RECOGNISED: {
        id: 165,
        message: 'Card Scheme Not Recognised',
    },
    TRANSACTION_TYPE_NOT_ALLOWED: {
        id: 166,
        message: 'Transaction Type Not Allowed',
    },
    INVALID_CARD_SECURITY_CODE: {
        id: 169,
        message: 'Invalid Card Security Code',
    },
    MERCHANT_RECEIPT: {
        id: 170,
        message: 'Printing Merchant Receipt',
        icon: 'print',
    },
    INVALID_AUTH_CODE: {
        id: 186,
        message: 'Invalid Auth Code',
    },
    PIN_BLOCKED: {
        id: 173,
        message: 'PIN Blocked',
        icon: 'warning-sign',
    },
    PIN_TRY_LIMIT_EXCEEDED: {
        id: 174,
        message: 'PIN Try Limit Exceeded',
        icon: 'warning-sign',
    },
    CANNOT_CONTINUE_TRANSACTION: {
        id: 180,
        message: 'Cannot Continue Transaction',
    },
    PROMPT_FOR_AUTHORISATION_CODE: {
        id: 185,
        message: 'Prompt For Authorisation Code',
    },
    OFFLINE_TXN_FAILED: {
        id: 187,
        message: 'Offline Txn Failed',
    },
    CONTACTLESS_INITIALISATION_SUCCESS: {
        id: 190,
        message: 'Contactless Initialisation Success',
    },
    PIN_ENTERED: {
        id: 191,
        message: 'PIN Entered',
    },
    CARD_SWIPED: {
        id: 192,
        message: 'Card Swiped',
    },
    CANCELLING_TRANSACTION: {
        id: 194,
        message: 'Cancelling Transaction',
    },
    CARD_PRESENTED: {
        id: 195,
        message: 'Card Presented',
    },
    SERVER_ERROR: {
        id: 196,
        message: 'Server Error',
    },
    OPTIONAL_DOWNLOAD_AVAILABLE: {
        id: 204,
        message: 'Optional Download Available',
    },
    CARD_NOT_RECOGNISED: {
        id: 205,
        message: 'Card Not Recognised',
    },
    CARD_SCHEME_DOES_NOT_ALLOW_TRANSACTION: {
        id: 206,
        message: 'Card Scheme Does Not Allow Transaction',
    },
    CONNECTION_FAILED_DOWNLOAD: {
        id: 208,
        message: 'Connection Failed Download',
    },
    SUBMITTING_OFFLINE_TXNS: {
        id: 209,
        message: 'Submitting Offline Txns',
    },
    OFFLINE_STORE_IS_FULL: {
        id: 210,
        message: 'Offline Store is Full',
    },
    BARCODE_INITIALISATION: {
        id: 250,
        message: 'Barcode Initialisation',
    },
    BARCODE_RESULT: {
        id: 251,
        message: 'Barcode Result',
    },
    BARCODE_CLOSED: {
        id: 252,
        message: 'Barcode Closed',
    },
    BARCODE_SCAN_ITEM: {
        id: 253,
        message: 'Barcode Scan Item',
    },
    AWAITING_KBD_CAPTURE: {
        id: 254,
        message: 'Awaiting KBD Capture',
    },
    AWAITING_NFC_SMART_CARD: {
        id: 255,
        message: 'Awaiting NFC Smart Card',
    },
    CUSTOMER_RECEIPT_REQUIRED_QUERY: {
        id: 256,
        message: 'Customer Receipt Required Query',
    },
    CUSTOMER_RECEIPT: {
        id: 530,
        message: 'Printing Customer Receipt',
        icon: 'print',
    },
    DISCONNECT: {
        id: 1001,
        message: 'Disconnect',
    },
};

module.exports = Statuses;
